'use client';
import classNames from 'classnames/bind';
import React from 'react';
import styles from './FixedLayer.module.scss.mjs';

const cx = classNames.bind(styles);
function FixedLayer(_ref) {
  let {
    children,
    isPreRender = false,
    direction
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', direction, {
      hide: isPreRender
    })
  }, children);
}

export { FixedLayer as default };
